import { styled } from '@mui/system';
import DialogContentText from '@mui/material/DialogContentText';

import { getSectionNavMediumColor } from 'styles/helpers/getThemeStyles';

const StyledDialogContentText = styled(DialogContentText)(({ theme }) => ({
  color: getSectionNavMediumColor(theme)
}));

export default StyledDialogContentText;
